import { useEffect } from "react";

/**
 * Calls a setter function when value changes.
 */
export default function useUpdateOnChange<T>(
  value: T,
  setter: (val: T) => void
): void {
  useEffect(() => {
    setter(value);
  }, [value]);
}
